// Exported methods to log BIMSearch application events in our log

import { currentUser } from "./IUsers";
import { postToServer } from "./CommonFunctions";

// log error method
// errorLocation - code location of error
// error - error string | use js excetion object toString() for unknown excetion
export async function logError(errorLocation, error) {
    var data = [errorLocation, error];
    var url = `/api/log/error`;

    logEvent(url, data);
}

async function logEvent(url, data) {
    postToServer(url, data);
}

function getUserId() {
    var userId = "NA";
    if (currentUser != null && currentUser.userId != null)
        userId = currentUser.userId;
    else
        logError("FrontEnd.src.utils.builder.IAmecLog.logClusterButton", "Can't get user ID");

    return userId;
}
